module.exports = __webpack_public_path__ + "static/media/431151343_1095486408164892_6131745614201897174_n.85743a62.jpg";